export const oppTypesMap = {
  RE: {
    chainPageUrl: '/chain/',
  },
  CU: {
    chainPageUrl: '/university/',
  },
  DI: {
    chainPageUrl: '/k12/',
  },
  HO: {
    chainPageUrl: '/hospital/',
  },
  NH: {
    chainPageUrl: '/nursinghome/',
  },
  LG: {
    chainPageUrl: '/lodging/chain/',
  },
  CS: {
    chainPageUrl: '/convenience/chain/',
  },
  UG: {
    chainPageUrl: '/company/',
  },
} as const

export const getChainPageUrl = (oppType: string, chainId: string): string => {
  return `${oppTypesMap[oppType as keyof typeof oppTypesMap].chainPageUrl}${oppType}${chainId}`
}
